import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { EditorModule } from '@tinymce/tinymce-angular';
import { TinyMceDialogAppendDirective } from '@app/_helpers/tiny-mce-dialog-append.directive';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';

import { NotesChatComponent } from './notes-chat.component';
import { NoteService } from '@app/_components/task/note/note.service';
import { AuthenticationService } from '@app/_services/authentication.service';
import { AlertService } from '@app/_services/alert.service';

@NgModule({
  declarations: [
    NotesChatComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    EditorModule,
    TinyMceDialogAppendDirective,
    CalendarModule,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    ButtonModule,
    ConfirmDialogModule,
    ToastModule,
    DialogModule,
    MultiSelectModule,
    TableModule
  ],
  providers: [
    NoteService,
    AuthenticationService,
    AlertService,
    ConfirmationService
  ],
  exports: [
    NotesChatComponent
  ]
})
export class NotesChatModule { }
